import React, { useContext } from 'react';

import TextButton from '../../../TextButton';
import { ToastContext } from '../../../Toast/ToastContext';
import { ToastActionProps } from './ToastAction.types';

const ToastAction = ({ dataHook, onClick, children }: ToastActionProps) => {
  const toastHidden = useContext(ToastContext)?.hidden ?? false;

  return (
    <TextButton
      dataHook={dataHook}
      skin="light"
      size="medium"
      underline="always"
      onClick={onClick}
      disabled={toastHidden}
    >
      {children}
    </TextButton>
  );
};

export default ToastAction;
